// dom related utility functions

/* eslint-disable */

/**
 * Given a DOM node and CSS selector, this function looks up the tree until it
 * finds another DOM node that matches the provided CSS selector.
 *
 * Modified polyfill for Element.closest found on MDN
 * https://goo.gl/8VF5W1
 *
 * @param {String} CSS selector
 * @param {HTMLElement} el Element to search relative from
 */
export function closest(selector, el) {
  let matches = document.querySelectorAll(selector),
    i;
  do {
    i = matches.length;
    while (--i >= 0 && matches.item(i) !== el) {};
  } while ((i < 0) && (el = el.parentElement));
  return el;
}

/**
 * Dom queries - saving carpal tunnel 😆.
 */

/**
 * Short hand for querySelector
 * @param {String} selector
 * @param {DOM Element} context
 */
export function select(selector, context = document) {
  return context.querySelector(selector);
}

/**
* Short hand for querySelectorAll
* @param {String} selector
* @param {DOM Element} context
*/
export function selectAll(selector, context = document) {
  return context.querySelectorAll(selector);
}

/**
 * Maps a callback to an element in an array-like object
 * Basically a copy of underscore's _.each
 * source: http://underscorejs.org/docs/underscore.html#section-20
 */
export function each(obj, iteratee, context) {
  let ctx = this;

  const isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  const has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  const _keys = function(obj) {
    if (!isObject(obj)) return [];
    if (Object.keys) return Object.keys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);

    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // source: https://github.com/darsain/isarraylike/blob/master/index.js
  const isArrayLike = function(value, complex) {
    return value
      && typeof value === 'object'
      && typeof value.length === 'number'
      && value.length >= 0
      && value.length % 1 === 0
      && (!complex || typeof value.splice === 'function');
  }

  if (context !== void 0) {
    ctx = context;
  }

  if (isArrayLike(obj)) {
    for (let i = 0, length = obj.length; i < length; i++) {
      iteratee.call(ctx, obj[i], i, obj);
    }
  } else {
    const keys = _keys(obj);
    for (let i = 0, length = keys.length; i < length; i++) {
      iteratee.call(ctx, obj[keys[i]], keys[i], obj);
    }
  }

  return obj;
}

/**
 * Returns `true` if provided input is Element.
 * @name isElement
 * @param {*} [input]
 * @returns {boolean}
 */
export function isElement(input) {
  return (input != null)
    && (typeof input === 'object')
    && (input.nodeType === Node.ELEMENT_NODE)
    && (typeof input.style === 'object')
    && (typeof input.ownerDocument === 'object');
}

/*! getSiblings.js | (c) 2017 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/getSiblings */
/**
 * Get all siblings of an element
 * @param  {Node}  elem The element
 * @return {Array}      The siblings
 */
export function siblings(elem) {
  var siblings = [];
  var sibling = elem.parentNode.firstChild;
  for (; sibling; sibling = sibling.nextSibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
  }
  return siblings;
}

/**
 * Get offset position of an element relative to document
 * @param  {Node}  el The element
 * @return {Array}      The siblings
 */
export function getOffset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

export function toggleExpandablePanel(event) {
  const element = event.srcElement;
  const buttonelement = element.closest(".expandable-panel-expand");
  const mainElement = element.closest(".expandable-panel");
  if (mainElement.classList.contains("expandable-panel-expanded")) {
    mainElement.classList.remove("expandable-panel-expanded");
    buttonelement.setAttribute("aria-expanded", "false");
  } else {
    mainElement.classList.add("expandable-panel-expanded");
    buttonelement.setAttribute("aria-expanded", "true");
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/utils/dom.js